module.exports = __webpack_public_path__ + "static/media/icon-qrcode-2.dbf4c235.svg";